import React from "react";
import useTranslation from "@hooks/use_translation";
import clearLogo from "@/images/clear_logo.svg";
import { cn } from "@/lib/utils";

interface ClearStyledButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

const ClearStyledButton: React.FC<ClearStyledButtonProps> = ({
  className = "",
  disabled,
  onClick,
  style,
  ...props
}) => {
  const { t } = useTranslation("clear_verification");
  const baseClasses =
    "bg-white relative rounded-full border border-black border-solid flex items-center justify-center gap-2 min-w-[180px] !px-8 !py-2 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed";

  const combinedClassName = cn(baseClasses, className);

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={combinedClassName}
      style={{ fontFamily: "'Inter', sans-serif", ...style }}
      {...props}
    >
      <div className="h-6 w-6 shrink-0 flex items-center justify-center">
        <img src={clearLogo} alt="CLEAR logo" className="h-5 w-5 object-contain" />
      </div>
      <div className="flex items-center text-black whitespace-nowrap">
        <span className="text-[14px] font-normal">{t("cta.verify_with_clear")}</span>
      </div>
    </button>
  );
};

export default ClearStyledButton;
